/** Shared presentation rules only. Never use these labels to authorize an action. */
export function userDisplayName(user: {
  firstName?: string | null;
  lastName?: string | null;
  username?: string | null;
  email?: string | null;
} | null | undefined): string {
  const name = [user?.firstName?.trim(), user?.lastName?.trim()].filter(Boolean).join(' ');
  return name || user?.username?.trim() || user?.email?.trim() || 'User';
}

/** Prefer an assigned administrator role; otherwise use a stable alphabetical label. */
export function primaryRoleLabel(roles: readonly string[] | null | undefined): string | null {
  const names = [...new Set((roles ?? []).map(role => role.trim().toLowerCase()).filter(Boolean))];
  const preferred = ['super_admin', 'system-admin', 'system_admin', 'admin', 'tenant-admin', 'tenant_admin'];
  const role = preferred.find(candidate => names.includes(candidate)) ?? names.sort()[0];
  return role?.replace(/[-_]/g, ' ').replace(/\b\w/g, letter => letter.toUpperCase()) ?? null;
}
